import { faPhoneArrowUp } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'
import {
  Button,
  ButtonVariation
} from '~/components/Global/Interactions/Button'
import { phoneDialString } from '~/utils/phone'

export const ContextPhoneButton = ({
  phone
}: {
  phone: string
}): ReactElement => (
  <Button
    href={phoneDialString(phone)}
    narrow
    variation={ButtonVariation.Neutral}
    buttonSize="extraSmall"
    aria-label="Appeler"
  >
    <FontAwesomeIcon icon={faPhoneArrowUp} />
  </Button>
)
